var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "registration-button",
      class: _vm.wrapperClasses,
      on: {
        mouseover: function ($event) {
          return _vm.handleMouseOver()
        },
        mouseleave: function ($event) {
          return _vm.handleMouseLeave()
        },
      },
    },
    [
      _c("ci-button", {
        class: _vm.innerClasses,
        attrs: {
          variant: _vm.buttonVariant,
          gated: true,
          disabled:
            _vm.event.participationState === "loading" ||
            _vm.participationCallFailed ||
            _vm.eventEndDate <= new Date(),
          buttonClass: _vm.buttonClass,
          icon: _vm.iconClass,
          label: _vm.buttonLabel,
        },
        on: { click: _vm.toggleRegistration },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }